import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PortalDataGridPro from '../../common/PortalDataGridPro';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { useState } from 'react';
import { getCodecsColumns } from './columns';

export default function Codecs({ id, title, codecs = [], onDeleteCodecs }) {
  const [isExpand, setIsExpand] = useState(false);

  const toggleIsExpand = () => {
    setIsExpand((prev) => !prev);
  };

  return (
    <>
      <Accordion
        elevation={0}
        expanded={isExpand}
        id={id + '__accordion'}
        className={'myOdu__accordion myOdu__border p-2'}
        sx={{
          width: '100%',
          p: 0,
          m: 0,
        }}
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon id={id + '__icon_chevronDown'} icon={faChevronDown} size="lg" />
          }
          id={id + '__accordionSummary'}
          aria-controls={id + '__accordionDetails'}
          sx={{
            m: 0,
            p: 0,
            flexDirection: 'row-reverse',
            flexGrow: 1,
          }}
          onClick={toggleIsExpand}
        >
          <Typography id={id + '__text_title'} variant="h6" component="h4">
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          //NOTE: when the AccordionSummary is provided with a aria-control it automatically makes
          // an id for the AccordionDetails with that ID
          // So this LOC is not needed:
          // id={ id + '__accordionDetails' }
          sx={{}}
        >
          <PortalDataGridPro
            className="myOdu__resultTable inner"
            rows={codecs}
            id={`${id}__dataGrid`}
            columns={getCodecsColumns({
              id,
              onDelete: onDeleteCodecs,
            })}
            sx={{
              '& .MuiDataGrid-cell--pinnedLeft': {
                zIndex: '10 !important',
              },
              '& .MuiDataGrid-cell': {
                whiteSpace: 'nowrap !important',
                minHeight: '3rem',
                alignContent: 'center',
              },
            }}
            getRowId={(row) => row.uid}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
            }}
            pagination
            getRowHeight={(params) => {
              return 'auto';
            }}
            disableRowSelectionOnClick
            slots={{
              noRowsOverlay: () => {
                return (
                  <Box
                    mt={1}
                    display="flex"
                    justifyContent="center"
                    id={`${id}__box_noResultsWrapper`}
                  >
                    <Typography
                      variant="p"
                      component="p"
                      style={{ margin: 4 }}
                      id={`${id}__p_noResults`}
                    >
                      No codecs.
                    </Typography>
                  </Box>
                );
              },
            }}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}
